// errors.ts
// Shared API error model for lms-nextjs.
// All fetch errors from lmsClient should be caught and classified here.

export class ApiError extends Error {
  constructor(
    public message: string,
    public status: number,
    public code?: string,
    public retriable: boolean = false
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function parseApiError(err: unknown): ApiError {
  if (err instanceof ApiError) return err;
  if (err instanceof Error) return new ApiError(err.message, 0);
  return new ApiError('An unknown error occurred', 0);
}
